import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/system';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomBorderLinearProgress = styled(LinearProgress)(function (_ref) {
  var _ref2;

  var height = _ref.height,
      borderRadius = _ref.borderRadius;
  return _ref2 = {
    height: height || 8,
    borderRadius: borderRadius || 4
  }, _defineProperty(_ref2, "&.".concat(linearProgressClasses.colorPrimary), {
    backgroundColor: '#E2E2E2'
  }), _defineProperty(_ref2, "& .".concat(linearProgressClasses.bar), {
    borderRadius: borderRadius || 4,
    backgroundColor: '#0E35D1'
  }), _ref2;
});

var BorderLinearProgress = function BorderLinearProgress(props) {
  return /*#__PURE__*/_jsx(CustomBorderLinearProgress, _objectSpread({}, props));
};

export default BorderLinearProgress;